import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { PreferenceName as PreferenceNameType } from '../types';

const T_PREFIX = 'dynamic_matching.freelancer_preferences';
export const PreferenceName = ({ name }: { name: PreferenceNameType }) => (
  <Typography
    as="p"
    color="grey_900"
    lineHeight="b_md"
    size={{ default: 'b_sm', sm: 'b_md' }}
    minWidth="160px"
    width="160px"
  >
    <I18n k={`${T_PREFIX}.fields.${name}.title`} />
  </Typography>
);
